import { FC, useState } from "react";
import { Question } from "survey-core";
import { SurveyQuestionElementBase } from "survey-react-ui";

// eslint-disable-next-line no-restricted-imports
import { Dropdown, Stack, TextField } from "@fluentui/react";

import { irnNumbers } from "../CustomFunctions/medicareOptions";
import { registerWidget } from "./registerWidget";

const QUESTION_TYPE = "bpMedicareNumber";

export class MedicareNumberFieldsModel extends Question {
  constructor(props: string) {
    super(props);
    this.choices = [];
  }

  getType() {
    return QUESTION_TYPE;
  }

  get choices() {
    return this.getPropertyValue("choices");
  }

  set choices(val) {
    this.setPropertyValue("choices", val);
  }

  public get maxChoices(): number {
    return this.getPropertyValue("maxChoices");
  }

  public set maxChoices(val: number) {
    this.setPropertyValue("maxChoices", val);
  }
}

export interface MedicareNumberFieldProps {
  value?: string;
  onChange: (value?: string) => void;
}

const formatMedicareNumber = (medicareNumber: string) => {
  if (medicareNumber.length >= 10) {
    return `${medicareNumber.substring(0, 4)} ${medicareNumber.substring(
      4,
      9
    )} ${medicareNumber[9]}`;
  } else if (medicareNumber.length >= 5) {
    return `${medicareNumber.substring(0, 4)} ${medicareNumber.substring(
      4,
      9
    )}`;
  }
  return medicareNumber;
};

const MedicareNumberField: FC<MedicareNumberFieldProps> = ({ onChange }) => {
  const [irn, setIrn] = useState("");
  const [medicareNumber, setMedicareNumber] = useState("");

  return (
    <Stack horizontal tokens={{ childrenGap: 16 }}>
      <TextField
        styles={{ root: { flexGrow: 1 } }}
        value={formatMedicareNumber(medicareNumber)}
        onChange={(_event, value) => {
          const newValue = value?.replaceAll(/[^0-9]/g, "");
          setMedicareNumber(newValue ?? "");
          onChange(`${newValue ?? ""}${irn}`);
        }}
        autoComplete="off"
        aria-autocomplete="none"
      />
      <Dropdown
        options={irnNumbers()}
        styles={{ root: { flexGrow: 1 } }}
        onChange={(_event, item) => {
          setIrn(item?.data ?? "");
          onChange(`${medicareNumber}${item?.data ?? ""}`);
        }}
      />
    </Stack>
  );
};

class MedicareNumberQuestion extends SurveyQuestionElementBase {
  constructor(props: any) {
    super(props);
    this.question.getSelectBaseRootCss = () => "";
  }

  get question() {
    return this.questionBase as MedicareNumberFieldsModel;
  }

  onChange = (value?: string | string[]) => {
    this.question.value = value;
  };

  renderElement = () => (
    <MedicareNumberField value={this.question.value} onChange={this.onChange} />
  );
}

export const registerMedicareNumberFields = () => {
  registerWidget({
    baseQuestion: QUESTION_TYPE,
    newQuestionName: QUESTION_TYPE,
    renderer: MedicareNumberQuestion,
    newToolboxItem: {
      name: QUESTION_TYPE,
      title: "Medicare number",
      elementsJSON: {
        choices: [],
        value: [],
        visible: true
      }
    },
    newModelFn: name => new MedicareNumberFieldsModel(name),
    extraProperties: []
  });
};
